export default __webpack_public_path__ + "static/Kalam-Regular-beab1b1782cb5690ee0e08071b206775.woff";